<template>
  <!-- eslint-disable -->
  <div class="p-2 w-full" v-loading="!showContent">
    <div v-if="showContent" class="w-full">
      <h6 class="my-4 text-center" v-if="printable">{{title}}</h6>
      <h4 class="my-4 text-center" v-else>{{title}}</h4>
      <div
        class="w-full justify-between space-x-0 space-y-2 lg:space-x-2 lg:space-y-0 my-4"
      >
        <DoughnutChart
          class="w-full m-auto"
          ref="chartRenderer"
          :chart-data="chartdata"
          :options="options"
          :height="height"
          :class="hideChart() ? 'hidden' : ''"

          @rawChart="setChartBaseSource($event)"
        />
        <img
          ref="imageRenderer"
          class="m-auto w-auto h-32"
          :src="chartBaseSource"

          v-if="printable"
        />

        <div class="w-full mt-2 grid grid-cols-2 gap-2">
          <div
            v-for="(item, index) in chartLegend"
            :key="index"
            class="w-full text-left flex mb-2"
          >
            <div class="border border-transparent rounded-full h-3 w-3" :style="`background-color: ${item.color}`"></div>
            <div class="pl-2 w-full flex justify-between">
              <div class="text-blue-600 text-sm">{{ item.name }}</div>
              <strong class="text-sm bold">{{ item.value }} {{ item.unit }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import CurrentValue from '@/components/widget/CurrentValue'
import DoughnutChart from '@/components/Chart/Doughnut'

export default {
  components: {
    DoughnutChart,
    CurrentValue
  },
  props: {
    title: {
      type: String
    },
    reportData: {
      type: Array
    },
    printable: {
      type: Boolean,
      default: () => false
    },
    chartCount: {
      type: Number
    }
  },
  data() {
    return {
      height: 190,
      chartdata: {
        labels: [],
        datasets: []
      },
      options: {
        plugins: {
          datalabels: {
            align: 'center',
            anchor: 'center',
            color: 'white',
            display: false
          }
        },
        cutoutPercentage: 50,
        responsive: false,
        maintainAspectRatio: false,
        legend: {
          display: false
        },
        title: {
          display: false,
          text: 'Chart.js Doughnut Chart'
        },
        animation: {
          animateScale: true,
          animateRotate: true
        },
        pieceLabel: {
          render: 'label',
          fontColor: 'var(--gray-900)',
          render: function (args) {
            return args.value + ' U'
          },
          position: 'outside',
          segment: true
        }
      },
      chartLegend: [],
      showContent: false,
      chartBaseSource: ''
    }
  },
  mounted() {
    this.setChartData()
  },
  methods: {
    setChartData(reportData) {
      // set reportData
      if (!reportData) {
        reportData = this.reportData
      }

      this.showContent = false

      // reset chart data
      this.chartdata = {
        labels: [],
        datasets: []
      }

      // set dateset
      this.chartdata.datasets = [
        {
          data: reportData.map((x) => x.AverageVal),
          backgroundColor: this.randomColors(),
          label: reportData.map((x) => x.GroupName)
        }
      ]

      // chart labels
      this.chartdata.labels = reportData.map((x) => x.GroupName)

      // chart legend
      var _this = this
      this.chartLegend = this.nestedSort(
        'value',
        reportData.map((x, index) => ({
          name: x.GroupName,
          value: x.AverageVal,
          unit: x.Unit,
          color: _this.chartdata.datasets[0].backgroundColor[index]
        }))
      )

      this.showContent = true
    },
    randomColors() {
      const ColorScheme = require('color-scheme')
      var scheme = new ColorScheme()
      scheme.scheme('contrast').distance(1).variation('default')

      const chartColors = scheme.colors().map((x) => `#${x}`)

      return chartColors.sort(() => 0.5 - Math.random())
    },
    hideChart() {
      return this.chartBaseSource !== '' && this.printable
    },
    setChartBaseSource(value) {
      this.chartBaseSource = value
    },
    nestedSort(prop, arr) {
      prop = prop.split('.')
      var len = prop.length

      arr.sort(function (a, b) {
        var i = 0
        while (i < len) {
          a = a[prop[i]]
          b = b[prop[i]]
          i++
        }
        if (a > b) {
          return -1
        } else if (a < b) {
          return 1
        } else {
          return 0
        }
      })
      return arr
    }
  },
  watch: {
    reportData: {
      deep: true,
      handler(val) {
        if (val) {
          this.setChartData(val)
        }
      }
    }
  }
}
</script>
